import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import getData from './actions/getData'
import Flights from './components/index'
import resetError from 'shared/errorHandler/actions/resetError'

const mapStateToProps = (state) => {
    return ({
        error: state.error.message,
        data: state.flights.data,
        isLoading: state.flights.isLoading,
        username: state.user.username
    })
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({
        getData,
        resetError
    }, dispatch)
})

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Flights))



// WEBPACK FOOTER //
// ./src/screens/flights/index.js